<template>
  <div>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <b-tabs v-model="activeTab">
          <b-tab active @click="changeTabs('draft')">
            <template #title>
              <tab-title
                  label="Produtos em rascunho"
                  :tab-key="TabKeyEnum.DRAFT"
              />
            </template>
            <TableProductsDraft
              :coins="coins"
              :modal-accept-for-approval="modalAcceptForApproval"
              :modal-deny-for-approval="modalDenyForApproval"
              :active-tab="activeTabName"
              @update-accept-for-approval="modalAcceptForApproval = false"
              @update-deny-for-approval="modalDenyForApproval = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab @click="changeTabs('aprovar')">
            <template #title>
              <tab-title
                  label="Produtos para Aprovação"
                  :tab-key="TabKeyEnum.APROVAR"
              />
            </template>
            <TableProductsForApproval
              :coins="coins"
              :modal-accept-for-approval="modalAcceptForApproval"
              :modal-deny-for-approval="modalDenyForApproval"
              :active-tab="activeTabName"
              @update-accept-for-approval="modalAcceptForApproval = false"
              @update-deny-for-approval="modalDenyForApproval = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab @click="changeTabs('pre-aprovados')">
            <template #title>
              <tab-title
                  label="Produtos Pré-Aprovados"
                  :tab-key="TabKeyEnum.PRE_APROVADOS"
              />
            </template>
            <TableProductsPreApproved
              :coins="coins"
              :modal-accept-for-approval="modalAcceptForApproval"
              :modal-deny-for-approval="modalDenyForApproval"
              :active-tab="activeTabName"
              @update-accept-for-approval="modalAcceptForApproval = false"
              @update-deny-for-approval="modalDenyForApproval = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab @click="changeTabs('aprovados-ia')">
            <template #title>
              <tab-title
                  label="Aprovados pela IA"
                  :tab-key="TabKeyEnum.APROVADOS_IA"
              />
            </template>
            <TableProductsIAApproved
              :coins="coins"
              :modal-accept-for-approval="modalAcceptForApproval"
              :modal-deny-for-approval="modalDenyForApproval"
              :active-tab="activeTabName"
              @update-accept-for-approval="modalAcceptForApproval = false"
              @update-deny-for-approval="modalDenyForApproval = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab @click="changeTabs('revisao')">
            <template #title>
              <tab-title
                  label="Produtos para Revisão"
                  :tab-key="TabKeyEnum.REVISAO"
              />
            </template>
            <TableProductsRevision
              :coins="coins"
              :modal-accept-for-approval="modalAcceptForApproval"
              :modal-deny-for-approval="modalDenyForApproval"
              :active-tab="activeTabName"
              @update-accept-for-approval="modalAcceptForApproval = false"
              @update-deny-for-approval="modalDenyForApproval = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab @click="changeTabs('aprovados')">
            <template #title>
              <tab-title
                  label="Produtos Aprovados"
                  :tab-key="TabKeyEnum.APROVADOS"
              />
            </template>
            <TableProductsApproved
              :coins="coins"
              :modal-deny-approved="modalDenyApproved"
              :active-tab="activeTabName"
              @update-deny-approved="modalDenyApproved = false"
              @open-detail="detail"
            />
          </b-tab>
          <b-tab v-if="canViewProductsOffers" @click="changeTabs('ofertas')">
            <template #title>
              <tab-title
                  label="Ofertas"
                  :tab-key="TabKeyEnum.OFERTAS"
              />
            </template>
            <TableOffers :coins="coins" :active-tab="activeTabName" @open-detail="detailFromOffers"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <ModalDetails
      :product-id="detailsProductId"
      :type="stateToProduct"
      :preselected-offer-id="preselectedOfferId"
      @accept="accept"
      @deny="deny"
    />
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import ModalDetails from './modal-details.vue'
import TableProductsForApproval from './tableProductsForApproval.vue'
import TableProductsIAApproved from './tableProductsIAApproved.vue'
import TableProductsApproved from './tableProductsApproved.vue'
import TableOffers from './tableOffers.vue'
import TableProductsRevision from './tableProductsRevision.vue'
import TableProductsPreApproved from './tableProductsPreApproved.vue'
import TableProductsDraft from './tableProductsDraft.vue'

import CurrencyCurrenciesService from "@services/resources/CurrencyCurrenciesService";
import TabTitle from "@views/products/tabTitle.vue";
import { TabKeyEnum } from "@views/products/enums/productStatusEnum";
import {AccessLevel} from "@views/configurations/enums/accessLevel";

const serviceCurrencyCurrencies = CurrencyCurrenciesService.build();

export default {
  page: {
    title: 'Produtos',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {
    TabTitle,
    PageHeader,
    ModalDetails,
    TableProductsForApproval,
    TableProductsIAApproved,
    TableProductsApproved,
    TableOffers,
    TableProductsRevision,
    TableProductsPreApproved,
    TableProductsDraft
  },
  computed: {
    activeTabName() {
      switch (this.activeTab) {
        case 0:
          return 'draft'
        case 1:
          return 'aprovar'
        case 2:
          return 'pre-aprovados'
        case 3:
          return 'aprovados-ia'
        case 4:
          return 'revisao'
        case 5:
          return 'aprovados'
        case 6:
          return 'ofertas'
        default:
          return 'aprovar'
      }
    },
    canViewProductsOffers() {
      if (this.useActionPermissions) {
        return this.$canAction('products_show_offers', AccessLevel.READER)
      }

      return true
    },
  },
  data() {
    return {
      TabKeyEnum,
      detailsProductId: 0,
      coins: [],
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Produtos',
          active: true,
        },
      ],
      modalAcceptForApproval: false,
      modalDenyForApproval: false,
      modalDenyApproved: false,
      preselectedOfferId: 0,
      stateToProduct: 'DRAFT',
      title: 'Produtos',
      activeTab: 0, // first tab 0 is the default one
    }
  },
  mounted() {
    this.fetchCurrencies();
  },
  methods: {
    /**
     * When user selects a different tab, the "this.stateToProduct" variable will be set to the corresponding status that must be sent in the request triggered by fetchProducts
     * @param selectedTab - String
     * @return no return
     * @author Sandro Souza
     */
    changeTabs(selectedTab) {
      // This stateToProduct control is used inside the modalDetails
      if (selectedTab === 'aprovados') {
        this.stateToProduct = 'APPROVED'
      } else if (selectedTab === 'alterados') {
        this.stateToProduct = 'REVISION'
      } else if (selectedTab === 'pre-aprovados') {
        this.stateToProduct = 'PRE-APPROVED'
      } else if (selectedTab === 'ofertas') {
        this.stateToProduct = 'offers'
      }
      else if (selectedTab === 'aprovar') {
        this.stateToProduct = 'REQUESTED'
      } 
      else if (selectedTab === 'draft') {
        this.stateToProduct = 'DRAFT'
      }
      else {
        this.stateToProduct = 'DRAFT'
      }
    },
    /**
     * Brings the data of all currencies to send to the components of each table to do the currency filter
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    fetchCurrencies() {
      serviceCurrencyCurrencies
        .search({query: "all"})
        .then((response) => {
          this.coins = response.sort((a, b) => {
            if (a.id > b.id) return 1;
            if (a.id < b.id) return -1;
            return 0;
          })
        })
        .catch(err => console.error(err))
    },
    // Actions
    /**
     * Fires on accept event of the details modal. Sends a varivale that is watched to the tableProductsForApproval component, it will open SweetAlert2 to approve product
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    accept() {
      if (this.stateToProduct === 'REQUESTED') this.modalAcceptForApproval = true;
    },
    /**
     * Fires on the deny event of the details modal, it sends a varivale that is watched to the tableProductsForApproval component, or to the tableProductsApproved component, depending on the selected tab, it will open SeetAlert2 to refuse product
     * @params no params
     * @return no return
     * @author Sandro Souza
     */
    deny() {
      if (this.stateToProduct === 'REQUESTED') this.modalDenyForApproval = true;
      if (this.stateToProduct === 'APPROVED') this.modalDenyApproved = true;
    },
    /**
     * Fires on the open-detail event of the tableProductsForApproval, tableProductsApproved components. Opens the details modal of selected product
     * @param productId - Object
     * @return no return
     * @author Sandro Souza
     */
    detail(productId) {
      this.preselectedOfferId = 0
      this.detailsProductId = productId
      this.$bvModal.show('details')
    },
    /**
     * Fires on the open-detail event of the offers table. Opens the details
     * modal and preselects the offer so its change history opens on top.
     * @param payload - Object { productId, offerId }
     * @return no return
     * @author Erick
     */
    detailFromOffers(payload) {
      this.preselectedOfferId = payload.offerId || 0
      this.detailsProductId = payload.productId
      this.$bvModal.show('details')
    }
    // ----------------------
  }
}
</script>

<style lang="scss">
.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.tab-content {
  padding: 0 !important;
}

.card-box {
  border-radius: 0 0 3px 3px;
}
</style>
